import { HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { APIEndpointMethods } from '@constant/api-endpoint-methods';
import { ApiWrapperService } from './api-wrapper.service';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private readonly apiWrapperService = inject(ApiWrapperService);

  /**
   * Checks the current under maintenance status from the API
   * @returns
   */
  checkUnderMaintenanceStatus() {
    const headers = new HttpHeaders({
      'isloaderDisable': 'true',
    });
    return this.apiWrapperService.get(APIEndpointMethods.checkUnderMaintenanceStatus, null, null, headers);
  }
}
